module.exports = __webpack_public_path__ + "static/pu-fbe0dc62c96d0307e8e024a81be4b44f.svg";